import {makeStyles} from 'tss-react/mui'

export const useStyles = makeStyles()(() => ({
  searchInput: {
    '&:hover': {
      backgroundColor: 'transparent'
    },
    '& .MuiInputBase-root': {
      backgroundColor: 'transparent !important',
      border: '1px solid #D1D9E0',
      borderRadius: '4px'
    },
    '& .MuiInputBase-input': {
      padding: '20px 8px 4px 8px'
    },
    '& .Mui-disabled': {
      opacity: 0.3
    },
    '&.Mui-focused': {
      border: '1px solid #D1D9E0'
    }
  },
  searchInputError: {
    '& .MuiInputBase-root': {
      borderColor: 'rgba(218, 9, 1, 1)'
    }
  },
  searchInputLabel: {
    color: '#00374d',
    left: '-4px',
    top: '-4px',
    border: 'none',
    lineHeight: '16px !important'
  }
}))
